import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loading from '../common/Loading.js';
import ErrorMessage from '../common/ErrorMessage.js';
import ArtistService from '../../services/artistService';
import * as textUtils from '../../utils/textUtils';
import * as browserCheck from '../../utils/browserCheck.js';
import ToastrService from '../../services/toastrService';
import urls from '../../constants/urls';
import { Redirect } from 'react-router-dom';
import settings from '../../constants/settings.js';
import MaterialInput from '../common/MaterialInput.js';
/* global google */

class EditFindMe extends React.Component {
    constructor(props, context) {
        super(props, context);      
        this.initialise = this.initialise.bind(this);
        this.updateAddress = this.updateAddress.bind(this);   
        this.updateField = this.updateField.bind(this);   
        this.initialiseAddressAutoComplete = this.initialiseAddressAutoComplete.bind(this);
        this.processPlaceAddress = this.processPlaceAddress.bind(this);
        this.state = {
            profile: this.props.profile,
            loading: false,
            Country: this.props.countries.length ? this.props.countries.find(c => c.Name === this.props.profile.Country).Code : null,
            Address: [],
            Latitude: null,
            Longitude: null
        };
     }

    componentWillMount() {
        if(!this.props.countries.length) {
            this.props.actions.getCountries();
        }
        this.initialise();
    }

    componentDidMount() { 
        window.componentHandler.upgradeDom();  
        const {getmdlSelect} = require('../../scripts/getmdl-select.js');
        getmdlSelect.init('#divCreateProfile .getmdl-select');   
        this.initialiseAddressAutoComplete();
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextProps.profile.ID !== this.props.profile.ID) {
            this.setState({
                profile: nextProps.profile,
                Country: this.props.countries.length ? this.props.countries.find(c => c.Name === nextProps.profile.Country).Code : null,
                Address: [],
                Latitude: null,
                Longitude: null
            }, this.initialise);
        }
        else if(nextProps.countries.length && !this.props.countries.length) {
            this.setState({
                Country: nextProps.countries.find(c => c.Name === this.props.profile.Country).Code
            }, this.initialiseAddressAutoComplete);
        }
    }

    componentDidUpdate(prevProps, prevState) {
    }

    initialise() {
        this.setState({ loading: true, error: null });        
        this.props.actions.getAddress(this.state.profile.ID)
            .then(addressData => {
                this.setState({ loading: false, Address: addressData.Address, Latitude: addressData.Latitude, Longitude: addressData.Longitude });
            })
            .catch(error => this.setState({ loading: false }));
    }

    updateAddress(event) {
        event.preventDefault();
        if(!this.state.Address || this.state.Latitude == null) {
            this.setState({ error: "Please enter the address" });
        }
        else {
            this.setState({ error: null });
            const address = {
                Address: this.state.Address,
                Latitude: this.state.Latitude,
                Longitude: this.state.Longitude
            };            
            this.props.actions.updateAddress(this.state.profile.ID, address)
            .then(updatedAddress => {
                const toastrService = new ToastrService();
                toastrService.showSuccess('', 'The changes have been saved successfully');
                this.setState({
                    Address: updatedAddress.Address,
                    Latitude: updatedAddress.Latitude,
                    Longitude: updatedAddress.Longitude,
                    error: null
                });
                this.props.actions.clearProfileAddress(this.state.profile.ID);
            }) 
            .catch(error => {
                this.setState({ error: error.message });
            });
        }
    }

    updateField(event) {
        const name = (event.target.name || event.target.attributes['name'].value);
        let value;
        if(event.target.className === 'mdl-checkbox__input') {
            value = event.target.checked;
        }
        else if (event.target.className === 'mdl-menu__item') {
            value = event.target.dataset.val;// event.target.innerText;
        }  
        else {
            value = event.target.value;
        }
        const state = {...this.state};
        state[name] = value;
        this.setState(state);
    }

    initialiseAddressAutoComplete() {
        if(this.state.Country) {
            const updateCallback = (address, latitude, longitude) => {
                const state = {...this.state};
                state.Address = address;
                state.Latitude = latitude;
                state.Longitude = longitude;
                this.setState(state);
            };

            const address = this.addressInput;
            const optionsAddress = {
                componentRestrictions: { country: this.state.Country }
            };
            let attempts = 0;
            const initAutoCompleteWhenReady = () => {
                if(window.google) {
                    const autocompleteAddress = new google.maps.places.Autocomplete(address, optionsAddress);
                    google.maps.event.addListener(autocompleteAddress, 'place_changed', () => {
                        const place = autocompleteAddress.getPlace();
                        this.processPlaceAddress(place, updateCallback);
                    });
                }
                else if(attempts < 10) {
                    window.setTimeout(initAutoCompleteWhenReady, 1000);
                    attempts++;
                }                
            };
            initAutoCompleteWhenReady();            
        }
    }

    processPlaceAddress(place, updateCallback) {
        const componentForm = {
            street_number: 'short_name',
            route: 'long_name',
            locality: 'long_name',
            postal_town: 'long_name',
            administrative_area_level_2: 'long_name',
            sublocality_level_1: 'long_name',
            administrative_area_level_1: 'long_name',
            country: 'long_name',
            postal_code: 'short_name'
        };
        let placeName = place.name;
        let placeStreetNumber;
        let placeRoute;
        let placeDistrict;
        let placeCity;
        let placeState;
        let placeCountry;
        let placePostalCode;
        let placeAddress;
        for (let i = 0; i < place.address_components.length; i++) {
            let addressType = place.address_components[i].types[0];
            if (componentForm[addressType]) {
                let val = place.address_components[i][componentForm[addressType]];
                if (addressType == 'street_number') {
                    placeStreetNumber = val;
                }
                else if (addressType == 'route') {
                    placeRoute = val;
                }
                else if (addressType == 'sublocality_level_1' || addressType == 'administrative_area_level_2') {
                    placeDistrict = val.replace('City of London', 'London');
                }
                else if (addressType == 'locality' || addressType == 'postal_town') {
                    placeCity = val;
                }
                else if (addressType == 'administrative_area_level_1') {
                    placeState = val;
                }
                else if (addressType == 'country') {
                    placeCountry = val;
                }
                else if (addressType == 'postal_code') {
                    placePostalCode = val;
                }
            }
        }
        if (placeCity == undefined) {
            placeCity = placeDistrict;
        }
        let address = '';
        if (placeStreetNumber != undefined) {
            address = placeStreetNumber + ' ';
        }
        if (placeRoute != undefined) {
            address += placeRoute + ', ';
        }
        if (placeCity != undefined) {
            address += placeCity + ', ';
        }
        if (placeState != undefined) {
            address += placeState + ', ';
        }
        if (placeCountry != undefined) {
            address += placeCountry + ', ';
        }
        if (placePostalCode != undefined) {
            address += placePostalCode + ', ';
        }
        updateCallback(`${address.substring(0, address.length - 2)}`, place.geometry.location.lat(), place.geometry.location.lng());
    }

    render() {
        const addressSet = this.state.Address && this.state.Latitude !== null && this.state.Longitude !== null;
        const mapUrl = addressSet ? `https://www.google.com/maps/embed/v1/place?q=${this.state.Address}&zoom=16&key=${settings.GOOGLEPLACES_KEY}` : '';
        return (
            !ArtistService.showFindMe(this.props.profile.RoleType) ?
                <Redirect to="/Profile/Manage" />
                :
                <div id="divCreateProfile">       
                    <form id="frmAddLocation" className="form-tightfields form-regular" onSubmit={this.updateAddress}> 
                        <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />       
                        <MaterialInput name="Address" className={`${!this.state.Country ? 'is-disabled' : 'is-dirty'}`}  placeholder="Type an address to search..." disabled={!this.state.Country} inputRef={(control) => this.addressInput = control} value={this.state.Address} onChange={this.updateField} required autoComplete="off" />                 
                        <MaterialInput name="Latitude" className={addressSet ? 'is-dirty' : ''} value={addressSet ? this.state.Latitude : ''} onChange={this.updateField} readOnly />
                        <MaterialInput name="Longitude" className={addressSet ? 'is-dirty' : ''} value={addressSet ? this.state.Longitude : ''} onChange={this.updateField} readOnly />
                        <div className="embed-container">
                            <iframe id="mapFrame" width="520" height="400" style={{border: 'solid 1px #aaa', display: addressSet ? 'inline' : 'none'}} src={mapUrl}/>
                        </div>
                        <br />
                        <br />
                        <input type="submit" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-button--wide" value="SAVE" onClick={this.addVideo} />                                  
                    </form>
                </div> 
                               
        );
    }
}

EditFindMe.propTypes = {
    profile: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    countries: PropTypes.array
};

export default EditFindMe;